(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name MiscentrosController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('MiscentrosController', MiscentrosController);

    MiscentrosController.$inject = ["UserService","$timeout","$location",'$anchorScroll'];

    function MiscentrosController(UserService,$timeout,$location,$anchorScroll)
    {

    	var vm = this;
    	vm.newCentro = {}
    	vm.paso = 1;
        vm.code = 0;
        vm.loading = false;
    	vm.msg = "";
    	vm.selectCentro = function(limps_id){
    		vm.newCentro = {};
    		vm.newCentro.id = limps_id;
    		vm.paso = 2;
    	}

    	vm.registrarCentro = function(){
            vm.loading = true;
    		UserService.registrarCentro(vm.newCentro,function(data){
                
                vm.msg=data.msg;
    			vm.code = data.code;
                if(vm.code==1){
                    setTimeout(function(){
                        vm.loading=false;
                        window.location.reload();
                    },1000)
                }else{
                    vm.loading=false;
                }
            });
    	}
               
    }


})();